import { render, staticRenderFns } from "./the-groups.vue?vue&type=template&id=ad137180&scoped=true"
import script from "./the-groups.vue?vue&type=script&lang=js"
export * from "./the-groups.vue?vue&type=script&lang=js"
import style0 from "./the-groups.vue?vue&type=style&index=0&id=ad137180&prod&scoped=true&lang=css"
import style1 from "./the-groups.vue?vue&type=style&index=1&id=ad137180&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad137180",
  null
  
)

export default component.exports